import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import React, { useState, useMemo, useContext } from 'react';
import { StyledMenu, StyledMenuWrap, StyledMenuWrapBox, StyledMenuButton, StyledMenuButtonLine, StyledMenuButtonClose } from './styles';
var MenuContext = React.createContext(false);
export function MenuButtonClose(props) {
  var setOpen = useContext(MenuContext)[1];
  return /*#__PURE__*/React.createElement(StyledMenuButtonClose, Object.assign({
    id: "menuButtonClose",
    className: props.className,
    onClick: function onClick() {
      return setOpen(false);
    },
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function MenuButton(props) {
  var setOpen = useContext(MenuContext)[1];
  return /*#__PURE__*/React.createElement(StyledMenuButton, Object.assign({
    id: "menuButton",
    className: props.className,
    onClick: function onClick() {
      return setOpen(true);
    },
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), /*#__PURE__*/React.createElement(StyledMenuButtonLine, null), /*#__PURE__*/React.createElement(StyledMenuButtonLine, null), /*#__PURE__*/React.createElement(StyledMenuButtonLine, null), props.children);
}
export function MenuWrapBox(props) {
  var open = useContext(MenuContext)[0];
  return /*#__PURE__*/React.createElement(StyledMenuWrapBox, Object.assign({
    id: "menuWrapBox",
    className: props.className,
    style: props.style,
    open: open
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function MenuWrap(props) {
  return /*#__PURE__*/React.createElement(StyledMenuWrap, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function Menu(props) {
  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var context = useMemo(function () {
    return [open, setOpen];
  }, [open, setOpen]);
  return /*#__PURE__*/React.createElement(MenuContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(StyledMenu, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style,
    layout: props.layout
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children));
}